import { Box, Container, Typography } from '@mui/material';
import CustomButton from './CustomButton';

const HeroBanner = ({
  // Content props
  logoSrc = "https://cdn.shopify.com/s/files/1/0261/6318/3691/files/Maniko_logo.png?v=1693840112",
  logoAlt = "MANIKO Logo",
  logoWidth = '220px',
  title = "Welcome",
  subtitle = "Please enter your information below to continue.",
  
  // Layout props
  backgroundColor = '#f9f9f9',
  textAlign = 'center',
  maxWidth = 'xs',
  containerPadding = 4,
  
  // Button configurations
  primaryButton = {
    text: 'Get Started',
    color: '#121212',
    hoverColor: '#d5d5d5',
    textColor: 'white',
    hoverTextColor: '#000',
    width: '100%',
    show: true,
    onClick: () => {},
  },
  
  secondaryButton = {
    text: 'Learn More',
    color: 'transparent',
    hoverColor: '#f0f0f0',
    textColor: '#555',
    hoverTextColor: '#000',
    width: '100%',
    show: false,
    onClick: () => {},
    variant: 'outlined',
  },
  
  // Responsive settings
  mobileSettings = {
    logoWidth: '180px',
    titleFontSize: '1.5rem',
    subtitleFontSize: '1rem',
    containerPadding: 2,
  },
  
  // Children components (forms, etc.)
  children,
  
  // Additional styling
  customStyles = {},
}) => {
  return (
    <Box
      sx={{
        position: 'absolute',
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: backgroundColor,
        textAlign: textAlign,
        px: 2,
        ...customStyles,
      }}
    >
      <Container 
        maxWidth={maxWidth} 
        sx={{ 
          overflow: 'auto', 
          py: containerPadding,
          // Mobile responsive padding
          '@media (max-width: 600px)': {
            py: mobileSettings.containerPadding,
          },
        }}
      >
        {/* Logo */}
        <Box
          component="img"
          src={logoSrc}
          alt={logoAlt}
          sx={{
            width: logoWidth,
            marginBottom: 2,
            maxWidth: '100%',
            height: 'auto',
            // Mobile responsive logo
            '@media (max-width: 600px)': {
              width: mobileSettings.logoWidth,
            },
          }}
        />
        
        {/* Title */}
        {title && (
          <Typography 
            variant="h4" 
            component="h1"
            sx={{ 
              color: '#333', 
              mb: 2, 
              fontWeight: 600,
              // Mobile responsive title
              '@media (max-width: 600px)': {
                fontSize: mobileSettings.titleFontSize,
              },
            }}
          >
            {title}
          </Typography>
        )}
        
        {/* Subtitle */}
        {subtitle && (
          <Typography 
            variant="body1" 
            sx={{ 
              color: '#888', 
              mb: 4, 
              fontSize: '1.1rem',
              // Mobile responsive subtitle
              '@media (max-width: 600px)': {
                fontSize: mobileSettings.subtitleFontSize,
                mb: 3,
              },
            }}
          >
            {subtitle}
          </Typography>
        )}
        
        {/* Children content (forms, etc.) */}
        {children}
        
        {/* Button Container */}
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
            mt: children ? 2 : 0,
            // Mobile responsive button container
            '@media (max-width: 600px)': {
              gap: 1.5,
            },
          }}
        >
          {/* Primary Button */}
          {primaryButton.show && (
            <CustomButton
              text={primaryButton.text}
              color={primaryButton.color}
              hoverColor={primaryButton.hoverColor}
              textColor={primaryButton.textColor}
              hoverTextColor={primaryButton.hoverTextColor}
              width={primaryButton.width}
              onClick={primaryButton.onClick}
              fullWidth={primaryButton.width === '100%'}
              variant={primaryButton.variant || 'contained'}
              type={primaryButton.type || 'button'}
            />
          )}
          
          {/* Secondary Button */}
          {secondaryButton.show && (
            <CustomButton
              text={secondaryButton.text}
              color={secondaryButton.color}
              hoverColor={secondaryButton.hoverColor}
              textColor={secondaryButton.textColor}
              hoverTextColor={secondaryButton.hoverTextColor}
              width={secondaryButton.width}
              onClick={secondaryButton.onClick}
              fullWidth={secondaryButton.width === '100%'}
              variant={secondaryButton.variant || 'outlined'}
              type={secondaryButton.type || 'button'}
              boxShadow={secondaryButton.variant === 'outlined' ? 'none' : undefined}
              hoverBoxShadow={secondaryButton.variant === 'outlined' ? 'none' : undefined}
            />
          )}
        </Box>
      </Container>
    </Box>
  );
};

export default HeroBanner; 